import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const StressLevels = lazyWithPreload(() => import('./StressLevels'))
